"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "vallata": {
    "4a9b8960": [{
      "hkey": "c4f08d32",
      "slug": "vallata",
      "name": "Vallata",
      "primary": true,
      "skipSearch": false
    }],
    "macchialvio": [{
      "hkey": "c4f08d32",
      "slug": "vallata",
      "name": "Vallata",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ea125577": [{
      "hkey": "c4f08d32",
      "slug": "vallata",
      "name": "Vallata",
      "primary": true,
      "skipSearch": false
    }],
    "maggiano": [{
      "hkey": "c4f08d32",
      "slug": "vallata",
      "name": "Vallata",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ac1f09a2": [{
      "hkey": "c4f08d32",
      "slug": "vallata",
      "name": "Vallata",
      "primary": true,
      "skipSearch": false
    }],
    "mezzana-perazze": [{
      "hkey": "c4f08d32",
      "slug": "vallata",
      "name": "Vallata",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "40de606d": [{
      "hkey": "c4f08d32",
      "slug": "vallata",
      "name": "Vallata",
      "primary": true,
      "skipSearch": false
    }],
    "padula": [{
      "hkey": "c4f08d32",
      "slug": "vallata",
      "name": "Vallata",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4ede88a8": [{
      "hkey": "c4f08d32",
      "slug": "vallata",
      "name": "Vallata",
      "primary": true,
      "skipSearch": false
    }],
    "piano-delle-rose": [{
      "hkey": "c4f08d32",
      "slug": "vallata",
      "name": "Vallata",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "33777571": [{
      "hkey": "c4f08d32",
      "slug": "vallata",
      "name": "Vallata",
      "primary": true,
      "skipSearch": false
    }],
    "serra-mattina": [{
      "hkey": "c4f08d32",
      "slug": "vallata",
      "name": "Vallata",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8bf54df7": [{
      "hkey": "c4f08d32",
      "slug": "vallata",
      "name": "Vallata",
      "primary": true,
      "skipSearch": false
    }],
    "sferracavallo": [{
      "hkey": "c4f08d32",
      "slug": "vallata",
      "name": "Vallata",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;